<template>
    <footer>
        <p class="copyright">
            Copyright © David Cannon. All rights reserved.
        </p>
    </footer>
</template>

<script>
	export default {
		name: "Footer"
	}
</script>

<style scoped lang="scss">
    footer{
        margin-top: auto;

        p.copyright{
             margin: 3rem auto 1rem;
            font-size: 11px;
            text-align: center;
        }
    }

</style>